import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "gameConfig"
  }, [_c("el-form", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    ref: "elForm",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      "label-width": "200px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "游戏",
      prop: "game_id"
    }
  }, [_vm.gameConfig ? _c("game-select", {
    on: {
      change: _vm.selectGame
    },
    model: {
      value: _vm.game_id,
      callback: function callback($$v) {
        _vm.game_id = $$v;
      },
      expression: "game_id"
    }
  }) : _vm._e(), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.newGame
    }
  }, [_vm._v("新增游戏")])], 1), _c("h2", [_vm._v("基础设置")]), _c("el-form-item", {
    attrs: {
      label: "游戏名称",
      prop: "name"
    }
  }, [_c("el-input", {
    style: {
      width: "100%"
    },
    attrs: {
      placeholder: "请输入游戏名称",
      clearable: ""
    },
    model: {
      value: _vm.formData.name,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "name", $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "测试状态",
      prop: "game_type"
    }
  }, [_c("el-radio-group", {
    attrs: {
      size: "medium"
    },
    model: {
      value: _vm.formData.game_type,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "game_type", $$v);
      },
      expression: "formData.game_type"
    }
  }, _vm._l(_vm.game_typeOptions, function (item, index) {
    return _c("el-radio", {
      key: index,
      attrs: {
        label: item.value,
        disabled: item.disabled
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "游戏类型",
      prop: "categoryType"
    }
  }, [_c("el-radio-group", {
    attrs: {
      size: "medium"
    },
    model: {
      value: _vm.formData.category_type,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "category_type", $$v);
      },
      expression: "formData.category_type"
    }
  }, _vm._l(_vm.categoryTypeOptions, function (item, index) {
    return _c("el-radio", {
      key: index,
      attrs: {
        label: item.value,
        disabled: item.disabled
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "游戏分类",
      prop: "category"
    }
  }, [_c("el-checkbox-group", {
    attrs: {
      size: "medium"
    },
    model: {
      value: _vm.formData.category,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "category", $$v);
      },
      expression: "formData.category"
    }
  }, _vm._l(_vm.categoryOptions, function (item) {
    return _c("el-checkbox", {
      key: item.value,
      attrs: {
        label: item.value
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "游戏标签",
      prop: "tag"
    }
  }, [_c("el-input", {
    style: {
      width: "100%"
    },
    attrs: {
      placeholder: "请用英文,分标签，如 休闲,塔防",
      clearable: ""
    },
    model: {
      value: _vm.formData.tag,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "tag", $$v);
      },
      expression: "formData.tag"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "游戏描述",
      prop: "description"
    }
  }, [_c("el-input", {
    style: {
      width: "100%"
    },
    attrs: {
      type: "textarea",
      placeholder: "请输入游戏描述",
      autosize: {
        minRows: 4,
        maxRows: 4
      }
    },
    model: {
      value: _vm.formData.description,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "description", $$v);
      },
      expression: "formData.description"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "默认客服QQ",
      prop: "qq"
    }
  }, [_c("el-input", {
    style: {
      width: "100%"
    },
    attrs: {
      placeholder: "请输入默认客服QQ",
      clearable: ""
    },
    model: {
      value: _vm.formData.qq,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "qq", $$v);
      },
      expression: "formData.qq"
    }
  })], 1), _c("h2", [_vm._v("参数设置")]), !_vm.is_new ? _c("el-form-item", {
    attrs: {
      label: "游戏KEY",
      prop: "game_key"
    }
  }, [_c("el-input", {
    style: {
      width: "100%",
      color: "black"
    },
    attrs: {
      placeholder: "请输入游戏KEY",
      clearable: "",
      disabled: true
    },
    model: {
      value: _vm.formData.game_key,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "game_key", $$v);
      },
      expression: "formData.game_key"
    }
  })], 1) : _vm._e(), !_vm.is_new ? _c("el-form-item", {
    attrs: {
      label: "游戏SECRET",
      prop: "game_secret"
    }
  }, [_c("el-input", {
    style: {
      width: "100%",
      color: "black"
    },
    attrs: {
      placeholder: "请输入游戏SECRET",
      clearable: "",
      disabled: true
    },
    model: {
      value: _vm.formData.game_secret,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "game_secret", $$v);
      },
      expression: "formData.game_secret"
    }
  })], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "游戏正式链接",
      prop: "url"
    }
  }, [_c("el-input", {
    style: {
      width: "100%"
    },
    attrs: {
      placeholder: "请输入游戏正式链接",
      clearable: ""
    },
    model: {
      value: _vm.formData.url,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "url", $$v);
      },
      expression: "formData.url"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "游戏测试链接",
      prop: "url_test"
    }
  }, [_c("el-input", {
    style: {
      width: "100%"
    },
    attrs: {
      placeholder: "请输入游戏测试链接",
      clearable: ""
    },
    model: {
      value: _vm.formData.url_test,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "url_test", $$v);
      },
      expression: "formData.url_test"
    }
  })], 1), _c("h2", [_vm._v("素材相关")]), _c("el-form-item", {
    attrs: {
      label: "游戏ICON",
      prop: "logo"
    }
  }, [_c("upload-image", {
    attrs: {
      fileSize: 512,
      maxWH: 1080
    },
    model: {
      value: _vm.formData.logo,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "logo", $$v);
      },
      expression: "formData.logo"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "游戏截图",
      prop: "images"
    }
  }, [_c("upload-image", {
    attrs: {
      fileSize: 512,
      maxWH: 1080
    },
    model: {
      value: _vm.formData.images,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "images", $$v);
      },
      expression: "formData.images"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "游戏平台首页图标",
      prop: "index_logo"
    }
  }, [_c("upload-image", {
    attrs: {
      fileSize: 512,
      maxWH: 1080
    },
    model: {
      value: _vm.formData.index_logo,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "index_logo", $$v);
      },
      expression: "formData.index_logo"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      size: "large"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v("提交")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };